import Vue from "vue";

const state = () => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  loading: false
});

const mutations = {
  SET_PAGE(state, page) {
    Vue.set(state, "currentPage", Number(page) || 1);
  },
  SET_PAGE_SIZE(state, size) {
    Vue.set(state, "pageSize", Number(size) || 10);
  },
  SET_TOTAL(state, total) {
    Vue.set(state, "total", Number(total) || 0);
  },
  SET_LOADING(state, val) {
    Vue.set(state, "loading", !!val);
  },
  SYNC_WITH_API_RESPONSE(state, apiData) {
    if (apiData.current_page)
      Vue.set(state, "currentPage", apiData.current_page);
    if (apiData.per_page) Vue.set(state, "pageSize", apiData.per_page);
    if (apiData.total !== undefined) Vue.set(state, "total", apiData.total);
  },
  RESET_PAGINACAO(state) {
    Vue.set(state, "currentPage", 1);
    Vue.set(state, "pageSize", 10);
    Vue.set(state, "total", 0);
  }
};

const getters = {
  currentPage: state => state.currentPage,
  pageSize: state => state.pageSize,
  total: state => state.total,
  loading: state => state.loading,
  apiParams: state => ({ page: state.currentPage, per_page: state.pageSize }),
  totalPages: state => Math.ceil(state.total / state.pageSize) || 1,
  offset: state => (state.currentPage - 1) * state.pageSize,
  hasNextPage: (state, getters) => state.currentPage < getters.totalPages,
  hasPrevPage: state => state.currentPage > 1,
  rangeStart: state =>
    state.total ? (state.currentPage - 1) * state.pageSize + 1 : 0,
  rangeEnd: state => {
    if (!state.total) return 0;
    const end = state.currentPage * state.pageSize;
    return Math.min(end, state.total);
  }
};

const actions = {
  setPage({ commit }, page) {
    commit("SET_PAGE", page);
  },
  setPageSize({ commit }, size) {
    commit("SET_PAGE_SIZE", size);
  },
  setTotal({ commit }, total) {
    commit("SET_TOTAL", total);
  },
  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },
  syncWithApi({ commit }, apiResponse) {
    commit("SYNC_WITH_API_RESPONSE", apiResponse);
  },
  resetarPaginacao({ commit }) {
    commit("RESET_PAGINACAO");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
